import { Breakpoint } from "@mui/material";

/** Width of the integration tiles depending on the breakpoint */
export const INTEGRATION_TILE_WIDTH: Partial<Record<Breakpoint, string>> = {
  xs: "100%",
  sm: "48%",
  lg: "32%",
};
